<div class="page-padding">
  <div class="panel">
    <div class="panel__header">
      <span class="panel__header__title">
        Undercarriage Rebuild Centre - {{jobNumber}} -
        Frame
      </span>

      <div class="panel__header__button-container">
        <a mat-raised-button target="_blank" href="/api/wsre/GetFramePdf?wsreid={{wsreId}}">
          <i class="material-icons button__icon">save_alt</i>
          PDF
        </a>
        <!--<a mat-raised-button target="_blank" href="/api/wsre/GetPdfFrame?wsreid={{wsreId}}">
          <i class="material-icons button__icon">save_alt</i>
          PDF
        </a>-->

        <button mat-raised-button color="warn" (click)="sendReport()">Send Report</button>
      </div>
    </div>
    <div class="panel__content flex flex--align-center">


      <img class="image--chain" src="/Content/Images/frame.jpg" alt="Frame">
      <div class="column-container flex-grow">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{customerName}}
            </span>
          </div>
          <!-- <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{jobsiteName}}
            </span>
          </div> -->
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <div class="component-container">
              <div matTooltip="Change Job Site" [matMenuTriggerFor]="changeJobSite" class="text-container"
                title="Click to edit" *ngIf="allowJobsiteEditing">
                <span class="text-container__text">
                  {{jobsiteName}}
                </span>
                <i class="material-icons text-container__edit" style="cursor: pointer" (click)="toggleJobSiteEdit(true)">
                  edit
                </i>
              </div>
              <div class="text-container" *ngIf="!allowJobsiteEditing">
                <span class="text-container__text">
                  {{jobsiteName}}
                </span>
              </div>
              <mat-menu #changeJobSite="matMenu" style="cursor: pointer">
                <button mat-menu-item *ngFor="let site of jobSiteList" (click)="saveJobSite(site)">
                  {{site.Name}}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="column-container__column">
          <!-- <div class="text-block">
            <span class="text-block__label">
              Serial Number
            </span>
            <span class="text-block__important">
              {{serialNumber}}
            </span>
          </div> -->
          <div class="text-block">
            <span class="text-block__label">
              Serial Number
              <span *ngIf="isSerialNumberEditable" class="text-block__important">
                <input class="input-container__input" [(ngModel)]="serialNumber" />
                <i class="material-icons save-button__icon editcancel " style="cursor: pointer;"
                  (click)="saveSerialNumber()">
                  check
                </i>
                <i class="material-icons cancel-button__icon editcancel" style="cursor: pointer;"
                  (click)="toggleSerialNumberEdit(false)">
                  close
                </i>
              </span>
            </span>
            <span *ngIf="!isSerialNumberEditable" class="text-block__important">
              {{serialNumber}}
              <i class="material-icons text-container__edit icon-size" style="cursor: pointer;"
                (click)="toggleSerialNumberEdit(true)" *ngIf="allowFieldEditing">
                edit
              </i>
            </span>
          </div>

          <div class="text-block">
            <span class="text-block__label">
              Inspection Date
            </span>
            <span class="text-block__important">
              {{inspectionDate | amDateFormat:'LL'}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Make
            </span>
            <span class="text-block__important">
              {{make}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Model
            </span>
            <span class="text-block__important">
              {{model}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Life Lived (hrs)
            </span>
            <span class="text-block__important">
              {{lifeLived}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Frame # LH Side
            </span>
            <span class="text-block__important">
              {{frameLHSideName}}
            </span>
          </div>
          <div class="text-block" style="display: none;">
            <span class="text-block__label">
              Customer Frame # LH Side
            </span>
            <span class="text-block__important">
              {{CustomerframeLHSide}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Job Number

              <span *ngIf="isJobNumberEditable" class="text-block__important">
                <input class="input-container__input" [(ngModel)]="jobNumber" />
                <i class="material-icons save-button__icon editcancel" style="cursor: pointer;"
                  (click)="saveJobNumber()">
                  check
                </i>
                <i class="material-icons cancel-button__icon editcancel" style="cursor: pointer;"
                  (click)="toggleJobNumberEdit(false)">
                  close
                </i>
              </span>
            </span>
            <span *ngIf="!isJobNumberEditable" class="text-block__important">
              {{jobNumber}}
              <i class="material-icons text-container__edit icon-size" style="cursor: pointer;"
                (click)="toggleJobNumberEdit(true)" *ngIf="allowFieldEditing">
                edit

              </i>
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Customer Reference

            </span>
            <span *ngIf="isCustomerReferenceEditable" class="text-block__important">
              <input class="input-container__input" [(ngModel)]="customerReference" />
              <i class="material-icons save-button__icon editcancel" style="cursor: pointer;"
                (click)="saveCustomerReference()">
                check
              </i>
              <i class="material-icons cancel-button__icon editcancel" style="cursor: pointer;"
                (click)="toggleCustomerReferenceEdit(false)">
                close
              </i>
            </span>
            <span *ngIf="!isCustomerReferenceEditable" class="text-block__important">
              {{customerReference}} <i class="material-icons text-container__edit icon-size" style="cursor: pointer;"
                (click)="toggleCustomerReferenceEdit(true)" *ngIf="allowFieldEditing">
                edit
              </i>
            </span>
          </div>


        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Old Job Number

            </span>
            <span *ngIf="isOldJobNumberEditable" class="text-block__important">
              <input class="input-container__input" [(ngModel)]="oldJobNumber" />
              <i class="material-icons save-button__icon editcancel" style="cursor: pointer;"
                (click)="saveOldJobNumber()">
                check
              </i>
              <i class="material-icons cancel-button__icon editcancel" style="cursor: pointer;"
                (click)="toggleOldJobNumberEdit(false)">
                close
              </i>
            </span>
            <span *ngIf="!isOldJobNumberEditable" class="text-block__important">
              {{oldJobNumber}} <i class="material-icons text-container__edit icon-size" style="cursor: pointer;"
                (click)="toggleOldJobNumberEdit(true)" *ngIf="allowFieldEditing">
                edit
              </i>
            </span>
          </div>

          <div class="text-block" style="display: none;">
            <span class="text-block__label">
              Customer Frame # RH Side
            </span>
            <span class="text-block__important">
              {{CustomerframeRHSide}}
            </span>
          </div>
          <!-- <div class="text-block">
            <span class="text-block__label">
              Frame # RH Side
            </span>
            <span class="text-block__important">
              {{frameRHSideName}}
            </span>
          </div> -->
          <div class="text-block">
            <span class="text-block__label">Frame # RH Side</span>
            <span *ngIf="isFrameRHSideEditable" class="text-block__important">
              <input class="input-container__input" [(ngModel)]="frameRHSideName" />
              <i class="material-icons save-button__icon editcancel" style="cursor: pointer;"
                (click)="saveFrameRHSide()">check</i>
              <i class="material-icons cancel-button__icon editcancel" style="cursor: pointer;"
                (click)="toggleFrameRHSideEdit(false)">close</i>
            </span>
            <span *ngIf="!isFrameRHSideEditable" class="text-block__important">{{frameRHSideName}}
              <i class="material-icons text-container__edit icon-size" style="cursor: pointer;"
                (click)="toggleFrameRHSideEdit(true)" *ngIf="allowFieldEditing">
                edit
              </i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel">
    <mat-tab-group (selectedTabChange)="viewTab($event)">
      <mat-tab label="Summary">
        <div style="display: flex" class="sc-row-margin">
          <div style="flex: 1" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">
            <!-- <div class="col-lg-3"></div> -->
            <div class="col-lg-9">
              <mat-label>Status Left Side: </mat-label>
              <mat-form-field style="margin-left: 5px;">
                <mat-select id="{{WSREStatusID}}Left" [(ngModel)]="WSREStatusIDLeftSide"
                  (selectionChange)="OnStatusChange(1, screenId.WF)" ngDefaultControl>
                  <mat-option [value]="dep.StatusId" *ngFor="let dep of WSREStatusLeftSide">
                    {{dep.StatusName}}
                  </mat-option>
                </mat-select>
              </mat-form-field><br />
              <span class="panel__header__title" style="font-weight: bold;
              font-size: initial;">
                Frame Left Side
              </span>
            </div>
            <div style="margin-top: 10px;">
              <span class="panel__header__title" style="font-weight: bold;
                font-size: initial;margin-left: 31%;">
              </span>
            </div>
            <div class="panel__content flex flex--top">

              <div class="center" *ngIf="loadingSummary">
                <mat-spinner></mat-spinner>
              </div>
              <ng-container *ngIf="!loadingSummary">
                <div class="eval Eval-{{overallEval}}" [class.saving-crack-test-eval]="savingOverallEval">
                  {{overallEval}}
                  <div class="change-eval" [matMenuTriggerFor]="overallEvalMenu" *ngIf="userCanEdit">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                  <mat-menu #overallEvalMenu="matMenu">
                    <button mat-menu-item (click)="saveOverallEval('A', screenId.WF)">A</button>
                    <button mat-menu-item (click)="saveOverallEval('B', screenId.WF)">B</button>
                    <button mat-menu-item (click)="saveOverallEval('C', screenId.WF)">C</button>
                    <button mat-menu-item (click)="saveOverallEval('X', screenId.WF)">X</button>
                  </mat-menu>
                </div>
                <div>
                  <div class="text-block">
                    <span class="text-block__label">Overall Summary Comment</span>
                    <span class="text-block__important">
                      <edit-data [canEdit]="userCanEdit" [value]="overallSummaryComment" [dataType]="'textarea'"
                        (valueChanged)="saveOverallSummaryComment($event, screenId.WF)">
                      </edit-data>
                    </span>
                  </div>
                  <div class="text-block">
                    <span class="text-block__label">Failed Iron</span>
                    <span class="text-block__important">
                      <edit-data [canEdit]="userCanEdit" [value]="overallSummaryRecommendation" [dataType]="'textarea'"
                        (valueChanged)="saveOverallSummaryRecommendation($event, screenId.WF)"></edit-data>
                    </span>
                  </div>

                </div>
              </ng-container>
            </div>
            <div style="background-color: #F5F8FB; padding: 16px 24px;overflow-x: auto;">
              <div style="display: flex; flex-direction: column;">
                <!-- <span style="font-size: 15px;font-weight: bold; margin-bottom: 1%;">Frame Configuration</span>
            <mat-radio-group name="_FrameConfigurationId" [(ngModel)]="FrameConfigurationId"
              (change)="FrameConfigurationChange($event)">
              <mat-radio-button [value]="1">Straight</mat-radio-button>
              <mat-radio-button [value]="2">TCY (Toe, Camber, Yaw)</mat-radio-button>
            </mat-radio-group> -->
                <!-- <div class="text-block"> -->
                <span style="font-size: 15px;font-weight: bold; margin-bottom: 1%;">{{ Translate('Frame Configuration')
                  }}</span>
                <mat-radio-group [(ngModel)]="toeOutFrameLeft" (change)="saveFrameConfiguration(1, toeOutFrameLeft, 1)">
                  <mat-radio-button [value]="2">{{ Translate('Straight') }}</mat-radio-button>
                  <mat-radio-button [value]="1">TCY (Toe, Camber, Yaw)</mat-radio-button>
                </mat-radio-group>
                <mat-radio-group [(ngModel)]="castFrameLeft" (change)="saveFrameConfiguration(2, castFrameLeft, 1)">
                  <mat-radio-button [value]="1">{{ Translate('Cast') }}</mat-radio-button>
                  <mat-radio-button style="margin-right: 18px;" [value]="2">{{ Translate('Fabricated')
                    }}</mat-radio-button>
                </mat-radio-group>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div style="flex: 1" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">
            <!-- <div class="col-lg-3"></div> -->
            <div class="col-lg-9">
              <mat-label>Status Right Side:</mat-label>
              <mat-form-field style="margin-left: 5px;">
                <mat-select id="{{WSREStatusID}}right" [(ngModel)]="WSREStatusIDRightSide"
                  (selectionChange)="OnStatusChange(2, screenId.WF)" ngDefaultControl>
                  <mat-option [value]="dep.StatusId" *ngFor="let dep of WSREStatusRightSide">
                    {{dep.StatusName}}
                  </mat-option>
                </mat-select>
              </mat-form-field><br />
              <span class="panel__header__title" style="font-weight: bold;
                font-size: initial;">
                Frame Right Side
              </span>
            </div>
            <div style="margin-top: 10px;">
              <span class="panel__header__title" style="font-weight: bold;
                font-size: initial;margin-left: 31%;">
              </span>
            </div>

            <div class="panel__content flex flex--top">

              <div class="center" *ngIf="loadingSummary">
                <mat-spinner></mat-spinner>
              </div>
              <ng-container *ngIf="!loadingSummary">
                <div class="eval Eval-{{OverallEvalR}}" [class.saving-crack-test-eval]="savingOverallEval_R">
                  {{OverallEvalR}}
                  <div class="change-eval" [matMenuTriggerFor]="overallEvalMenu_R" *ngIf="userCanEdit">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                  <mat-menu #overallEvalMenu_R="matMenu">
                    <button mat-menu-item (click)="saveOverallEval_R('A', screenId.WF)">A</button>
                    <button mat-menu-item (click)="saveOverallEval_R('B', screenId.WF)">B</button>
                    <button mat-menu-item (click)="saveOverallEval_R('C', screenId.WF)">C</button>
                    <button mat-menu-item (click)="saveOverallEval_R('X', screenId.WF)">X</button>
                  </mat-menu>
                </div>
                <div>
                  <div class="text-block">
                    <span class="text-block__label">Overall Summary Comment</span>
                    <span class="text-block__important">
                      <edit-data [canEdit]="userCanEdit" [value]="overallSummaryCommentRightSide"
                        [dataType]="'textarea'"
                        (valueChanged)="saveOverallSummaryCommentRightSide($event, screenId.WF)">
                      </edit-data>
                    </span>
                  </div>
                  <div class="text-block">
                    <span class="text-block__label">Failed Iron</span>
                    <span class="text-block__important">
                      <edit-data [canEdit]="userCanEdit" [value]="overallSummaryRecommendationRightSide"
                        [dataType]="'textarea'"
                        (valueChanged)="saveOverallSummaryRecommendationRightSide($event, screenId.WF)"></edit-data>
                    </span>
                  </div>

                </div>
              </ng-container>
            </div>
            <div style="background-color: #F5F8FB; padding: 16px 24px;overflow-x: auto;">
              <div style="display: flex; flex-direction: column;">
                <!-- <span style="font-size: 15px;font-weight: bold; margin-bottom: 1%;">Frame Configuration</span>
            <mat-radio-group name="_FrameConfigurationId" [(ngModel)]="FrameConfigurationId"
              (change)="FrameConfigurationChange($event)">
              <mat-radio-button [value]="1">Straight</mat-radio-button>
              <mat-radio-button [value]="2">TCY (Toe, Camber, Yaw)</mat-radio-button>
            </mat-radio-group> -->
                <!-- <div class="text-block"> -->
                <span style="font-size: 15px;font-weight: bold; margin-bottom: 1%;">{{ Translate('Frame Configuration')
                  }}</span>
                <mat-radio-group [(ngModel)]="toeOutFrameRight"
                  (change)="saveFrameConfiguration(1, toeOutFrameRight, 2)">
                  <mat-radio-button [value]="2">{{ Translate('Straight') }}</mat-radio-button>
                  <mat-radio-button [value]="1">TCY (Toe, Camber, Yaw)</mat-radio-button>
                </mat-radio-group>
                <mat-radio-group [(ngModel)]="castFrameRight" (change)="saveFrameConfiguration(2, castFrameRight, 2)">
                  <mat-radio-button [value]="1">{{ Translate('Cast') }}</mat-radio-button>
                  <mat-radio-button style="margin-right: 18px;" [value]="2">{{ Translate('Fabricated')
                    }}</mat-radio-button>
                </mat-radio-group>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>

      </mat-tab>

      <mat-tab label="Photos">
        <div style="display: flex" class="sc-row-margin">
          <div style="flex: 1" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">
            <div style="margin-top: 10px;">
              <span class="panel__header__title" style="font-weight: bold;
            font-size: initial;margin-left: 31%;">
                Frame Left Side
              </span>
            </div>
            <div class="panel__content">
              <div class="text-block">
                <span class="text-block__label">Arrival Photos</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="3"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>

                        </td>
                        <ng-container *ngFor="let photo of arrivalPhotos_L">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-radio-group>
                                <div style="width:100%;">
                                  <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                    (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                                </div>
                                <div style="width:100%;">
                                  <mat-radio-button [value]="photo" [checked]="photo.isMainPhoto"
                                    (change)="changeisMainPhoto($event)">Summary</mat-radio-button>
                                </div>
                              </mat-radio-group>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>

              <div class="text-block">
                <span class="text-block__label">Final Photo</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="17"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of finalPhotos_L">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-radio-group>
                                <div style="width:100%;">
                                  <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                    (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                                </div>
                                <div style="width:100%;">
                                  <mat-radio-button [value]="photo" [checked]="photo.isMainPhoto"
                                    (change)="changeisMainPhoto($event)">Summary</mat-radio-button>
                                </div>
                              </mat-radio-group>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>

              <div class="text-block">
                <span class="text-block__label">Customer Reference Photos</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="customerReferencePhotoUploaded($event)"
                            [uploadEndPoint]="4" [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of customerReferencePhotos_L">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
              <div class="text-block">
                <span class="text-block__label">Old Tag Photos</span>
                <div class="flex" style="flex-direction: column;">

                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="oldTagPhotoUploaded($event)" [uploadEndPoint]="5"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of oldTagPhotos_L">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
              <div class="text-block">
                <span class="text-block__label">Failed Iron Photos</span>
                <div class="flex" style="flex-direction: column;">

                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="failedIronPhotoUploaded($event)"
                            [uploadEndPoint]="11" [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of failedIronPhotos_L">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Summary</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
            </div>
          </div>
          <div style="flex: 1" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">
            <div style="margin-top: 10px;">
              <span class="panel__header__title" style="font-weight: bold;
            font-size: initial;margin-left: 31%;">
                Frame Right Side
              </span>
            </div>
            <div class="panel__content">
              <div class="text-block">
                <span class="text-block__label">Arrival Photos</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="6"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of arrivalPhotos_R">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-radio-group>
                                <div style="width:100%;">
                                  <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                    (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                                </div>
                                <div style="width:100%;">
                                  <mat-radio-button [value]="photo" [checked]="photo.isMainPhoto"
                                    (change)="changeisMainPhoto($event)">Summary</mat-radio-button>
                                </div>
                              </mat-radio-group>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>

              <div class="text-block">
                <span class="text-block__label">Final Photo</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="7"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of finalPhotos_R">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-radio-group>
                                <div style="width:100%;">
                                  <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                    (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                                </div>
                                <div style="width:100%;">
                                  <mat-radio-button [value]="photo" [checked]="photo.isMainPhoto"
                                    (change)="changeisMainPhoto($event)">Summary</mat-radio-button>
                                </div>
                              </mat-radio-group>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>

              <div class="text-block">
                <span class="text-block__label">Customer Reference Photos</span>
                <div class="flex" style="flex-direction: column;">
                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="customerReferencePhotoUploaded($event)"
                            [uploadEndPoint]="8" [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of customerReferencePhotos_R">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
              <div class="text-block">
                <span class="text-block__label">Old Tag Photos</span>
                <div class="flex" style="flex-direction: column;">

                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="oldTagPhotoUploaded($event)" [uploadEndPoint]="9"
                            [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of oldTagPhotos_R">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Body</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
              <div class="text-block">
                <span class="text-block__label">Failed Iron Photos</span>
                <div class="flex" style="flex-direction: column;">

                  <td class="table__eval-cell">
                    <table>
                      <tr>
                        <td class="right-gap5">
                          <upload-photo-wsre-frame (onPhotoUpload)="failedIronPhotoUploaded($event)"
                            [uploadEndPoint]="12" [relatedId]="wsreId"></upload-photo-wsre-frame>
                        </td>
                        <ng-container *ngFor="let photo of failedIronPhotos_R">
                          <td valign="bottom">
                            <img (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
                              class="component-photo" matTooltip="{{photo.Title}}" />
                            <div>
                              <mat-checkbox class="checkboxtext" [checked]="photo.IncludeInReport"
                                (change)="includeReportCheckboxchange($event, photo)">Summary</mat-checkbox>
                            </div>
                          </td>
                        </ng-container>
                      </tr>
                    </table>
                  </td>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel__content">
        </div>
      </mat-tab>
      <mat-tab label="Components">

        <div class="panel__content" *ngIf="viewComponents">


          <span>Include All</span> <mat-checkbox (change)="checkboxChanged($event)"
            [checked]="isshowDiv"></mat-checkbox>
          &nbsp;&nbsp;<span>Display Final Measurement</span> <mat-checkbox
            (change)="displayFinalMeasurementChanged($event)" [checked]="isEnableFinalMeasurement"></mat-checkbox>
          &nbsp;&nbsp;<span>Display Specs on report</span> <mat-checkbox (change)="displaySpecs($event)"
            [checked]="isEnableSpecs"></mat-checkbox>
          <ng-container *ngFor="let component of components">
            <div class="container" style="margin-top: 2%">


              <div *ngIf="component.CompartMeasurementPoints.length>0 &&  isshowDiv ==true" style="
            width: 100%;
            height: 100%;">
                <div>
                  <span style="font-weight: bold;font-size: 18px;">{{component.measurementPointName}}</span>

                </div>
                <div style="display: flex; flex-direction: row;" class="sc-row-margin">
                  <div>
                    <div class="panel__content">
                      <div style="display: flex" class="sc-row-margin">
                        <div style="flex: 1">
                          <table class="table table--full-width table--striped"
                            *ngIf="isshowDiv ==true || component.isShowMeasurementPoints==true">
                            <thead>
                              <tr>

                                <th style="color: black;">Ref.Image</th>
                                <th style="color: black;">Observation Pt.</th>
                                <th style="text-align: center; color: black;width: 25%;"
                                  *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">Left Side Frame</th>
                                <th style="text-align: center; color: black;width: 25%;"
                                  *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">Right Side Frame</th>
                                <th style="text-align: center; color: black;width: 25%;" *ngIf="isEnableSpecs==true">
                                  Specification</th>


                              </tr>
                              <tr>
                                <th></th>
                                <th></th>
                                <th *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">
                                  <div
                                    style="display: flex;flex-direction: row;justify-content: space-around; width: 360px;">
                                    <span style="text-align: -webkit-center;">Measurement <br>Initial</span>
                                    <span class="header_small">Pass/Fail</span>
                                    <span class="header_small">Images</span>
                                    <span *ngIf="isEnableFinalMeasurement==true"
                                      style="text-align: -webkit-center;">Measurement <br>Final</span>
                                    <span *ngIf="isEnableFinalMeasurement==true">Images</span>
                                  </div>
                                </th>
                                <th *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">
                                  <div
                                    style="display: flex;flex-direction: row;justify-content: space-around;width: 360px;">
                                    <span style="text-align: -webkit-center;">Measurement <br> Initial</span>
                                    <span class="header_small">Pass/Fail</span>
                                    <span class="header_small">Images</span>
                                    <span *ngIf="isEnableFinalMeasurement==true"
                                      style="text-align: -webkit-center;">Measurement<br> Final</span>
                                    <span *ngIf="isEnableFinalMeasurement==true" class="header_small">Images</span>

                                  </div>
                                </th>
                                <th *ngIf="isEnableSpecs==true">
                                  <div style="display: flex;flex-direction: row;justify-content: space-around;">
                                    <span>Spec</span>
                                    <span>Range</span>
                                  </div>
                                </th>



                              </tr>
                              <!-- <tr>
                        <th></th>
                        <th></th>
                        <th>
                          <span>Initial</span>
                        </th>
                        <th>
                          <span>Final</span>
                        </th>
                        <th></th>
                      </tr> -->
                            </thead>
                            <tbody *ngFor="let c of component.CompartMeasurementPoints">
                              <tr style="background-color: #E9EDF2">
                                <td class="component-cell">
                                  <div class="component-photo-container">
                                    <img [src]="c.ImageData" alt="Component photo" class="component-photo" />
                                  </div>
                                </td>
                                <td style="width: 30%;">{{c.compartName}}</td>

                                <td *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">
                                  <div
                                    style="display: flex;flex-direction: row;justify-content: space-around;width: 360px;">
                                    <mat-select *ngIf="c.ToolId == 9"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.Measurement"
                                      (selectionChange)="saveComponentMeasurementLeft(c.Measurement, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> A</mat-option>
                                      <mat-option [value]="2"> B</mat-option>
                                      <mat-option [value]="3"> C</mat-option>
                                      <mat-option [value]="4"> X</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <mat-select *ngIf="c.ToolId == 7"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.Measurement"
                                      (selectionChange)="saveComponentMeasurementLeft(c.Measurement, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> No</mat-option>
                                      <mat-option [value]="2"> Yes</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <mat-select *ngIf="c.ToolId == 10"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.Measurement"
                                      (selectionChange)="saveComponentMeasurementLeft(c.Measurement, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> Fail</mat-option>
                                      <mat-option [value]="2"> Pass</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <input *ngIf="c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10" class="{{c.eval_L}}"
                                      style="margin-right: 10px;width: 95px;margin-left:0px;" #txt type="text"
                                      name="field" (focus)="txt.setAttribute('data-value', c.Measurement)"
                                      (blur)="txt.getAttribute('data-value') !== c.Measurement ? saveComponentMeasurementLeft(c.Measurement, c.compartId, 1, c.compartName, c.Id,c.IsOk_L) : ''"
                                      [(ngModel)]="c.Measurement" />


                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_L != null && c.IsOk_L && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer; color: green;"
                                        (click)="ChangeIsOkCheckbox(2,1,c)"> check_box</i>
                                    </div>

                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_L != null && !c.IsOk_L && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer;color: red;"
                                        (click)="ChangeIsOkCheckbox(3,1,c)"> disabled_by_default</i>
                                    </div>
                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_L == null && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer;"
                                        (click)="ChangeIsOkCheckbox(1,1,c)"> check_box_outline_blank</i>
                                    </div>

                                    <div class="header_small">
                                      <upload-photo *ngIf="c.PhotoThumbnail_L == ''"
                                        (onPhotoUpload)="LoadObsPointFrameImage(c.Id,c,1,component.Id,0)"
                                        [inspectionId]="wsreId" [inspectionDetailId]="c.Id"
                                        [WSREMeasurementPointId]="component.Id" [Side]="1" [IsFinalMeasurementImg]="0"
                                        [isWSREFrameObs]=true></upload-photo>
                                      <i *ngIf="c.PhotoThumbnail_L != ''" class="material-icons upload-container__icon"
                                        style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                                        (click)="viewComponentPhoto(c.PhotoId_L,c.Id,1,c,component.Id,0)">
                                        add_a_photo
                                      </i>
                                    </div>


                                    <mat-select *ngIf="c.ToolId == 9 && isEnableFinalMeasurement==true"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.FinalMeasurement_L"
                                      (selectionChange)="saveComponentFinalMeasurementLeft(c.FinalMeasurement_L, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> A</mat-option>
                                      <mat-option [value]="2"> B</mat-option>
                                      <mat-option [value]="3"> C</mat-option>
                                      <mat-option [value]="4"> X</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <mat-select *ngIf="c.ToolId == 7 && isEnableFinalMeasurement==true"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.FinalMeasurement_L"
                                      (selectionChange)="saveComponentFinalMeasurementLeft(c.FinalMeasurement_L, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> No</mat-option>
                                      <mat-option [value]="2"> Yes</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <mat-select *ngIf="c.ToolId == 10 && isEnableFinalMeasurement==true"
                                      style="margin-right: 10px;width: 95px;margin-left: 0px;" class="{{c.eval_L}}"
                                      [(ngModel)]="c.FinalMeasurement_L"
                                      (selectionChange)="saveComponentFinalMeasurementLeft(c.FinalMeasurement_L, c.compartId, 1, c.compartName, c.Id)">
                                      <mat-option [value]="1"> Fail</mat-option>
                                      <mat-option [value]="2"> Pass</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>



                                    <input
                                      *ngIf="c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10 && isEnableFinalMeasurement==true"
                                      class="{{c.eval_L}}" style="margin-right: 10px;width: 95px;margin-left:0px;" #txt
                                      type="text" name="field"
                                      (focus)="txt.setAttribute('data-value', c.FinalMeasurement_L)"
                                      (blur)="txt.getAttribute('data-value') !== c.FinalMeasurement_L ? saveComponentFinalMeasurementLeft(c.FinalMeasurement_L, c.compartId, 1, c.compartName, c.Id,c.IsOk_L) : ''"
                                      [(ngModel)]="c.FinalMeasurement_L" />

                                    <upload-photo
                                      *ngIf="c.PhotoThumbnail_L_Final == '' && isEnableFinalMeasurement ==true"
                                      (onPhotoUpload)="LoadObsPointFrameImage(c.Id,c,1,component.Id,1)"
                                      [inspectionId]="wsreId" [inspectionDetailId]="c.Id"
                                      [WSREMeasurementPointId]="component.Id" [Side]="1" [IsFinalMeasurementImg]="1"
                                      [isWSREFrameObs]=true></upload-photo>
                                    <i *ngIf="c.PhotoThumbnail_L_Final != '' && isEnableFinalMeasurement"
                                      class="material-icons upload-container__icon"
                                      style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                                      (click)="viewComponentPhoto(c.PhotoId_L,c.Id,1,c,component.Id,1)">
                                      add_a_photo
                                    </i>
                                  </div>
                                </td>
                                <td *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">
                                  <div style="display: flex;flex-direction: row;justify-content: space-around;">
                                    <mat-select *ngIf="c.ToolId == 9" style="width: 95px;margin-left:7%"
                                      class="{{c.eval_R}}" [(ngModel)]="c.Measurement_RIGHT"
                                      (selectionChange)="saveComponentMeasurementRight(c.Measurement_RIGHT, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> A</mat-option>
                                      <mat-option [value]="2"> B</mat-option>
                                      <mat-option [value]="3"> C</mat-option>
                                      <mat-option [value]="4"> X</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <mat-select *ngIf="c.ToolId == 7" style="width: 95px;margin-left:7%"
                                      class="{{c.eval_R}}" [(ngModel)]="c.Measurement_RIGHT"
                                      (selectionChange)="saveComponentMeasurementRight(c.Measurement_RIGHT, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> No</mat-option>
                                      <mat-option [value]="2"> Yes</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <mat-select *ngIf="c.ToolId == 10" style="width: 95px;margin-left:7%"
                                      class="{{c.eval_R}}" [(ngModel)]="c.Measurement_RIGHT"
                                      (selectionChange)="saveComponentMeasurementRight(c.Measurement_RIGHT, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> Fail</mat-option>
                                      <mat-option [value]="2"> Pass</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <input *ngIf="c.ToolId != 7 && c.ToolId != 9 && c.ToolId!=10" class="{{c.eval_R}}"
                                      style="margin-right: 10px;width: 95px; " #txt type="text" name="field"
                                      (focus)="txt.setAttribute('data-value', c.Measurement_RIGHT)"
                                      (blur)="txt.getAttribute('data-value') !== c.Measurement_RIGHT ? saveComponentMeasurementRight(c.Measurement_RIGHT, c.compartId, 2, c.compartName, c.Id,c.IsOk_R) : ''"
                                      [(ngModel)]="c.Measurement_RIGHT" />

                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_R != null && c.IsOk_R && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer; color: green;"
                                        (click)="ChangeIsOkCheckbox(2,2,c)"> check_box</i>
                                    </div>

                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_R != null && !c.IsOk_R && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer;color: red;"
                                        (click)="ChangeIsOkCheckbox(3,2,c)"> disabled_by_default</i>
                                    </div>
                                    <div style="align-self: center;" class="header_small"
                                      *ngIf="c.IsOk_R == null && (c.ToolId != 7 && c.ToolId!=9 && c.ToolId!=10) ">
                                      <i class="material-icons" style="cursor: pointer;"
                                        (click)="ChangeIsOkCheckbox(1,2,c)"> check_box_outline_blank</i>
                                    </div>

                                    <div class="header_small">
                                      <upload-photo *ngIf="c.PhotoThumbnail_R == ''"
                                        (onPhotoUpload)="LoadObsPointFrameImage(c.Id_R,c,2,component.Id,0)"
                                        [inspectionId]="wsreId" [inspectionDetailId]="c.Id_R"
                                        [WSREMeasurementPointId]="component.Id" [Side]="2" [IsFinalMeasurementImg]="0"
                                        [isWSREFrameObs]=true></upload-photo>
                                      <i *ngIf="c.PhotoThumbnail_R != ''" class="material-icons upload-container__icon"
                                        style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                                        (click)="viewComponentPhoto(c.PhotoId_R,c.Id_R,2,c,component.Id,0)">
                                        add_a_photo
                                      </i>
                                    </div>

                                    <mat-select *ngIf="c.ToolId == 9 && isEnableFinalMeasurement==true"
                                      style="width: 95px;margin-left:7%" class="{{c.eval_R}}"
                                      [(ngModel)]="c.FinalMeasurement_R"
                                      (selectionChange)="saveComponentFinalMeasurementRight(c.FinalMeasurement_R, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> A</mat-option>
                                      <mat-option [value]="2"> B</mat-option>
                                      <mat-option [value]="3"> C</mat-option>
                                      <mat-option [value]="4"> X</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <mat-select *ngIf="c.ToolId == 7 && isEnableFinalMeasurement==true"
                                      style="width: 95px;margin-left:7%" class="{{c.eval_R}}"
                                      [(ngModel)]="c.FinalMeasurement_R"
                                      (selectionChange)="saveComponentFinalMeasurementRight(c.FinalMeasurement_R, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> No</mat-option>
                                      <mat-option [value]="2"> Yes</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <mat-select *ngIf="c.ToolId == 10 && isEnableFinalMeasurement==true"
                                      style="width: 95px;margin-left:7%" class="{{c.eval_R}}"
                                      [(ngModel)]="c.FinalMeasurement_R"
                                      (selectionChange)="saveComponentFinalMeasurementRight(c.FinalMeasurement_R, c.compartId, 2, c.compartName, c.Id)">
                                      <mat-option [value]="1"> Fail</mat-option>
                                      <mat-option [value]="2"> Pass</mat-option>
                                      <mat-option [value]="-123456"> N/A</mat-option>
                                    </mat-select>

                                    <input
                                      *ngIf="c.ToolId != 7 && c.ToolId != 9 && c.ToolId!=10 && isEnableFinalMeasurement==true"
                                      class="{{c.eval_R}}" style="margin-right: 10px;width: 95px; " #txt type="text"
                                      name="field" (focus)="txt.setAttribute('data-value', c.FinalMeasurement_R)"
                                      (blur)="txt.getAttribute('data-value') !== c.FinalMeasurement_R ? saveComponentFinalMeasurementRight(c.FinalMeasurement_R, c.compartId, 2, c.compartName, c.Id,c.IsOk_R) : ''"
                                      [(ngModel)]="c.FinalMeasurement_R" />

                                    <!-- </div>

                                  <div> -->
                                    <upload-photo
                                      *ngIf="c.PhotoThumbnail_R_Final == '' && isEnableFinalMeasurement==true"
                                      (onPhotoUpload)="LoadObsPointFrameImage(c.Id_R,c,2,component.Id,1)"
                                      [inspectionId]="wsreId" [inspectionDetailId]="c.Id_R"
                                      [WSREMeasurementPointId]="component.Id" [Side]="2" [IsFinalMeasurementImg]="1"
                                      [isWSREFrameObs]=true></upload-photo>
                                    <i *ngIf="c.PhotoThumbnail_R_Final != '' && isEnableFinalMeasurement==true"
                                      class="material-icons upload-container__icon"
                                      style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
                                      (click)="viewComponentPhoto(c.PhotoId_R,c.Id_R,2,c,component.Id,1)">
                                      add_a_photo
                                    </i>
                                  </div>
                                </td>
                                <td *ngIf="isEnableSpecs==true">
                                  <div style="display: flex;flex-direction: row;justify-content: space-around;">
                                    <mat-label>{{c.spec}} </mat-label>
                                    <mat-label>
                                      {{
                                      c.ToleranceType === 'Both' ? '+/- ' + c.range :
                                      c.ToleranceType === 'Minus' ? '- ' + c.range :
                                      c.ToleranceType === 'Plus' ? '+ ' + c.range :
                                      c.ToleranceType === 'Max' ? 'Max' :
                                      c.range
                                      }}
                                    </mat-label>
                                    <!-- <mat-label>{{c.range}} </mat-label> -->
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="panel__content">

                      <div style="padding: 0 24px !important;">
                        <div style="margin-top: 2%;">
                          <span style="font-size: large;
                    font-weight: bold;">Document</span>
                        </div>
                        <i class="material-icons" style="cursor: pointer;font-size: 40px;"
                          [title]="'Click to upload PDF file'  | translate | async" (click)="openAttachDoc(component)">
                          upload_file</i>
                        <i *ngIf="component.DocumnetData!=null" style="cursor: pointer;font-size: 40px; color: #3da14b;"
                          class="material-icons" (click)="onClickDownloadForm(component)">description</i>
                        <span *ngIf="component.FileName!=''"
                          style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;"
                          (click)="onClickDownloadForm(component)">{{component.FileName}}</span>

                      </div>



                      <div style="display: flex" class="sc-row-margin">


                        <!-- left side comment -->
                        <div style="flex: 1">
                          <div class="text-block">
                            <div class="flex" style="flex-direction: column;">
                              <td class="table__eval-cell">
                                <div style="margin-top: 2%;">
                                  <span style="font-size: large;
                                    font-weight: bold;">Images</span>
                                </div>
                                <upload-component-crack-photo (onPhotoUpload)="uploadComponentCrackPhotos($event)"
                                  [uploadEndPoint]="1" [relatedId]="wsreId"
                                  [WSREMeasurementPointID]="component.Id"></upload-component-crack-photo>
                                <ng-container *ngFor="let photo of ComponentCrackImages">
                                  <ng-container *ngIf="photo.WSREMeasurementPointId==component.Id && photo.side==1">
                                    <img (click)="openComponentImage(photo.Id, 'component')"
                                      [src]="getImage(photo.Image)" class="component-photo" />
                                  </ng-container>
                                </ng-container>
                              </td>
                            </div>
                          </div>

                          <div class="text-block">
                            <div class="flex" style="flex-direction: column;">
                              <td class="table__eval-cell">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 18px;" class="get-label">
                                  Comments</h4>


                                <textarea style="width: 500px; height: 100px;" #txt type="textarea" name="field"
                                  (focusout)=" saveComponentCommentFrame($event,component.Id, 1)"
                                  [(ngModel)]="component.comment_L"></textarea>

                              </td>
                            </div>
                          </div>
                        </div>

                        <!-- right side comment -->
                        <div style="flex: 1">
                          <div class="text-block">
                            <div class="flex" style="flex-direction: column;">
                              <td class="table__eval-cell">
                                <div style="margin-top: 2%;">
                                  <span style="font-size: large;
                                    font-weight: bold;">Images</span>
                                </div>
                                <upload-component-crack-photo (onPhotoUpload)="uploadComponentCrackPhotos($event)"
                                  [uploadEndPoint]="2" [relatedId]="wsreId"
                                  [WSREMeasurementPointID]="component.Id"></upload-component-crack-photo>

                                <ng-container *ngFor="let photo of ComponentCrackImages">
                                  <ng-container *ngIf="photo.WSREMeasurementPointId==component.Id && photo.side==2">
                                    <img (click)="openComponentImage(photo.Id, 'component')"
                                      [src]="getImage(photo.Image)" class="component-photo" />
                                  </ng-container>
                                </ng-container>
                              </td>
                            </div>
                          </div>

                          <div class="text-block">
                            <div class="flex" style="flex-direction: column; margin-top: 6%;">
                              <td class="table__eval-cell">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 18px;" class="get-label">
                                  Comments</h4>
                                <textarea style="width: 500px; height: 100px;" #txt type="textarea" name="field"
                                  (focusout)=" saveComponentCommentFrame($event,component.Id, 2)"
                                  [(ngModel)]="component.comment_R">  </textarea>
                              </td>
                            </div>
                          </div>
                        </div>


                      </div>

                    </div>
                  </div>
                  <div style="flex: 1">
                    <img [src]="component.ImageData" style="height: auto;width: 550px; margin-top: 110px;">
                  </div>
                </div>


                <!-- crack images, name and comment       -->

                <div style="display: flex" class="sc-row-margin">
                  <div style="flex: 1">
                    <div class="panel__content">
                      <td class="table__eval-cell">
                        <div style="margin-top: 2%;">
                          <span style="font-size: large;
                    font-weight: bold; cursor: pointer;"
                            (click)="openCrackrecordDialog(component.Id, 1 )">Cracks</span>
                          <mat-icon style="cursor: pointer;"
                            (click)="openCrackrecordDialog(component.Id , 1)">add</mat-icon>
                        </div>
                      </td>

                      <div *ngFor="let FrameCrackRecords of component.WSREFrameCrackRecordsVM">

                        <!--html design change-->
                        <table class="table table--full-width table--striped" *ngIf="FrameCrackRecords.side==1">

                          <tbody>
                            <tr>
                              <td>
                                <span>Name</span>
                                <input style="width: 150px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Name"
                                  (change)=" UpdateCrackNameFrame($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.name" />
                              </td>

                              <td>
                                <span>
                                  Crack Length ({{FrameCrackRecords.MeasurementType}})
                                </span> <input style="width: 82px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Crack Length"
                                  (change)=" UpdateCrackLength($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.CrackLength" />
                              </td>
                              <td>
                                <span> Comment</span>
                                <input style="width: 150px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Crack Comment"
                                  (change)=" UpdateCrackCommentFrame($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.comment" />
                              </td>
                            </tr>

                            <tr>


                              <td>

                                <div style="display: flex">
                                  <div>
                                    <span> Initial Crack Image</span>
                                    <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                      [uploadEndPoint]="1" [isFinalCrackImag]="0"
                                      [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                  </div>
                                  <div *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM ">

                                    <img *ngIf="!photo.IsCrackFinalImage"
                                      (click)="openComponentImage(photo.Id, 'crack')" [src]="photo.ImageData"
                                      class="component-photo" />

                                  </div>
                                </div>


                              </td>
                              <td>

                                <div style="display: flex">
                                  <div>
                                    <span> Final Crack Image</span>
                                    <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                      [uploadEndPoint]="1" [isFinalCrackImag]="1"
                                      [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                  </div>
                                  <div *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM">

                                    <img *ngIf="photo.IsCrackFinalImage" (click)="openComponentImage(photo.Id, 'crack')"
                                      [src]="photo.ImageData" class="component-photo" />

                                  </div>
                                </div>


                              </td>




                            </tr>
                          </tbody>
                        </table>
                        <!--html design change-->

                        <!-- <ng-container *ngIf="FrameCrackRecords.side==1">
                          <td class="table__eval-cell">
                            <div style="display: flex" class="sc-row-margin">
                              <div style="flex: 1">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">Crack
                                  Name</h4>
                                <input style="width: 110px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackNameFrame($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.name" />
                              </div>
                              &nbsp;
                              <div style="flex: 1">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">Crack
                                  Length</h4>
                                <input style="width: 110px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackLength($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.CrackLength" />
                              </div>

                              <div style="flex: 1; margin-left: 5px;">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">
                                  Comment</h4>
                                <input style="width: 200px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackCommentFrame($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.comment" />
                              </div>

                              <div style="flex: 1;">
                                <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                  [uploadEndPoint]="1"
                                  [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                <ng-container *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM">
                                  <img (click)="openComponentImage(photo.Id, 'crack')" [src]="photo.ImageData"
                                    class="component-photo" />
                                </ng-container>
                              </div>
                            </div>
                          </td>
                        </ng-container> -->
                      </div>

                    </div>
                  </div>
                  <div style="flex: 1">
                    <div class="panel__content">
                      <td class="table__eval-cell">
                        <div style="margin-top: 2%;">
                          <span style="font-size: large;
                    font-weight: bold; cursor: pointer;" (click)="openCrackrecordDialog(component.Id,2 )">Cracks</span>
                          <mat-icon style="cursor: pointer;"
                            (click)="openCrackrecordDialog(component.Id, 2)">add</mat-icon>
                        </div>
                      </td>

                      <div *ngFor="let FrameCrackRecords of component.WSREFrameCrackRecordsVM">


                        <!--html design change-->
                        <table class="table table--full-width table--striped" *ngIf="FrameCrackRecords.side==2">

                          <tbody>
                            <tr>
                              <td>
                                <span>Name</span>
                                <input style="width: 150px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Name"
                                  (change)=" UpdateCrackNameFrame($event, FrameCrackRecords.Id, component.Id, 2)"
                                  [(ngModel)]="FrameCrackRecords.name" />
                              </td>

                              <td>
                                <span>
                                  Crack Length ({{FrameCrackRecords.MeasurementType}})
                                </span> <input style="width: 82px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Crack Length"
                                  (change)=" UpdateCrackCommentFrame($event, FrameCrackRecords.Id, component.Id, 2)"
                                  [(ngModel)]="FrameCrackRecords.CrackLength" />
                              </td>
                              <td>
                                <span> Comment</span>
                                <input style="width: 150px; height: 30px;" #txt type="textarea" name="field"
                                  placeholder="Crack Comment"
                                  (change)=" UpdateCrackLength($event, FrameCrackRecords.Id, component.Id, 2)"
                                  [(ngModel)]="FrameCrackRecords.comment" />
                              </td>
                            </tr>

                            <tr>


                              <td>

                                <div style="display: flex">
                                  <div>
                                    <span> Initial Crack Image</span>
                                    <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                      [uploadEndPoint]="2" [isFinalCrackImag]="0"
                                      [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                  </div>
                                  <div *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM ">

                                    <img *ngIf="!photo.IsCrackFinalImage"
                                      (click)="openComponentImage(photo.Id, 'crack')" [src]="photo.ImageData"
                                      class="component-photo" />

                                  </div>
                                </div>


                              </td>
                              <td>

                                <div style="display: flex">
                                  <div>
                                    <span> Final Crack Image</span>
                                    <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                      [uploadEndPoint]="2" [isFinalCrackImag]="1"
                                      [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                  </div>
                                  <div *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM">
                                    <img *ngIf="photo.IsCrackFinalImage" (click)="openComponentImage(photo.Id, 'crack')"
                                      [src]="photo.ImageData" class="component-photo" />

                                  </div>
                                </div>


                              </td>




                            </tr>
                          </tbody>
                        </table>
                        <!--html design change-->
                        <!-- <ng-container *ngIf="FrameCrackRecords.side==2">
                          <td class="table__eval-cell">
                            <div style="display: flex" class="sc-row-margin">
                              <div style="flex: 1">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">Crack
                                  Name</h4>
                                <input style="width: 110px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackNameFrame($event, FrameCrackRecords.Id,component.Id, 2)"
                                  [(ngModel)]="FrameCrackRecords.name" />
                              </div>

                              &nbsp;
                              <div style="flex: 1">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">Crack
                                  Length</h4>
                                <input style="width: 110px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackLength($event, FrameCrackRecords.Id, component.Id, 1)"
                                  [(ngModel)]="FrameCrackRecords.CrackLength" />
                              </div>


                              <div style="flex: 1; margin-left: 5px;">
                                <h4 style=" margin-top: 2%; font-weight: bold; font-size: 15px;" class="get-label">
                                  Comment</h4>
                                <input style="width: 200px; height: 30px;" #txt type="textarea" name="field"
                                  (focusout)=" UpdateCrackCommentFrame($event, FrameCrackRecords.Id,component.Id, 2)"
                                  [(ngModel)]="FrameCrackRecords.comment" />
                              </div>

                              <div style="flex: 1;">


                                <upload-measurement-crack-photo (onPhotoUpload)="uploadCrackPhotos($event)"
                                  [uploadEndPoint]="2"
                                  [WSRECrackID]="FrameCrackRecords.Id"></upload-measurement-crack-photo>
                                <ng-container *ngFor="let photo of FrameCrackRecords.WsreComponentTabPhotoVM">
                                  <img (click)="openComponentImage(photo.Id, 'crack')" [src]="photo.ImageData"
                                    class="component-photo" />
                                </ng-container>
                              </div>
                            </div>
                          </td>
                        </ng-container> -->
                      </div>


                    </div>
                  </div>
                </div>


              </div>

            </div>
          </ng-container>

        </div>
      </mat-tab>

      <mat-tab label="Left" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==1">
        <div class="panel__content">
          <div class="columnsheadersmgr" *ngIf="isBasicUser==1">
            <mat-checkbox [(ngModel)]="editComponent" *ngIf="isAdministrator" class="margin">
              <span class="example-margin">
                {{"Edit Component" | translate | async}}
              </span>
            </mat-checkbox>
          </div>
        </div>

        <div class="table-container" [@slideOut] *ngIf=" LeftSideSystem!=null && LeftSideSystem.Components.length > 0">
          <table class="table table--full-width table--striped">
            <thead>
              <tr>

                <th></th>
                <th>{{'Component' | translate | async}}</th>
                <th>{{'Pos.' | translate | async}}</th>
                <th>{{'Worn' | translate | async}}</th>
                <th class="right-align" style="text-align-last: center;">{{'Measurement' | translate | async}}</th>
                <th>{{'Tool' | translate | async}}</th>
                <th class="inspection-component-photo-header">Photo</th>
                <th class="inspection-component-photo-header">Comment</th>
                <th class="inspection-component-photo-header">Hide/Show</th>
                <th class="inspection-component-photo-header">Record Actions</th>
                <th class="inspection-component-photo-header">New Component</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of LeftSideSystem.Components">
                <!-- 
                <td *ngIf="c.IsChild">
                  <span style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                  </span>
                </td> -->
                <td class="component-cell" *ngIf="!c.IsChild">
                  <div class="component-photo-container">
                    <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
                  </div>
                </td>
                <td *ngIf="c.IsChild" class="line-cell">
                  <div class="line-vert{{getChildRowPosition(c.ComponentId,LeftSideSystem)}}"></div>
                  <div class="line-hor"></div>
                </td>

                <td>
                  <span title="{{c.Name}}" *ngIf="!c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
                  </span>
                  <span title="{{c.Name}}" *ngIf="c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
                  </span>
                   <span *ngIf="editComponent && !c.IsChild">
                    <i
                      class="material-icons text-container__edit"
                      style="cursor:pointer;font-size:16px;"
                      title="Click to edit Component"
                      (click)="openEditComponentPopup(c)">
                      edit
                    </i>
                  </span>
                </td>
                <td> {{showPosition(c.Pos, c.ComponentTypeId,LeftSideSystem)}}</td>

                <td *ngIf="c.Active" class="table__eval-cell">
                  <span style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                    <div style="text-align: center !important; display: inline-block;">
                      <!-- Eval tool -->
                      <ng-container *ngIf="c.ToolId === toolType.Eval">
                        {{ c.EvalCode }}
                      </ng-container>

                      <!-- Yes/No or Pass/Fail -->
                      <ng-container *ngIf="c.ToolId === toolType.YESorNO || c.ToolId === toolType.PassorFail">
                        {{'-'}}
                      </ng-container>

                      <!-- All others -->
                      <ng-container
                        *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail">
                        {{ c.Measurement === -1 ? '-' : (c.WornPercentage.toFixed(1) + '%') }}
                      </ng-container>
                    </div>
                  </span>
                </td>
                <td *ngIf="!c.Active"></td>
                <td *ngIf="c.Active">
                  <div class="right-align"
                    *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail"
                    style="text-align-last: center;">

                    <input style="width: 100px;" type="number" [(ngModel)]="c.Measurement === -1 ? '' : c.Measurement"
                      (change)="updateComponentMeasurement(c.Measurement, c.InspectionDetailId, $event,c, screenId.WF)">
                    {{c.MeasurementType==1?'MM':'Inch'}}
                  </div>
                  <div class="center-align" *ngIf="c.ToolId === toolType.Eval">
                    <span [matMenuTriggerFor]="evalMenu" class="tool-button"
                      title="{{'Change Eval' | translate | async}}">{{c.EvalCode }}</span>
                    <mat-menu #evalMenu="matMenu">
                      <button mat-menu-item
                        (click)="changeEval('A', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'A'}}</button>
                      <button mat-menu-item
                        (click)="changeEval('B', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'B'}}</button>
                      <button *ngIf="c.isExcludeC==false" mat-menu-item
                        (click)="changeEval('C', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'C' }}</button>
                      <button mat-menu-item
                        (click)="changeEval('X', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'X'}}</button>
                    </mat-menu>
                  </div>

                  <div class="center-align" *ngIf='c.ToolId === toolType.YESorNO'>
                    <span [matMenuTriggerFor]="yesNoMenu" class="tool-button"
                      title="{{ 'Change Component Yes/No' | translate | async }}">
                      {{c.Measurement === 1 ? ('Yes' | translate | async) :
                      c.Measurement === 0 ? ('No' | translate | async) : ''}}
                    </span>
                    <mat-menu #yesNoMenu="matMenu">
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypeYesNo.Yes, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Yes' | translate | async }}</button>
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypeYesNo.No, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'No' | translate | async }}</button>
                    </mat-menu>
                  </div>
                  <div class="center-align" *ngIf='c.ToolId === toolType.PassorFail'>
                    <span [matMenuTriggerFor]="passFailMenu" class="tool-button"
                      title="{{ 'Change Component Pass/Fail' | translate | async }}">
                      {{ c.Measurement === 1 ? ('Pass' | translate | async) :
                      c.Measurement === 0 ? ('Fail' | translate | async) :''
                      }}
                    </span>
                    <mat-menu #passFailMenu="matMenu">
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypePassFail.Pass, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Pass' | translate | async }}</button>
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypePassFail.Fail, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Fail' | translate | async }}</button>
                    </mat-menu>
                  </div>
                </td>
                <td *ngIf="!c.Active"></td>
                <td *ngIf="c.Active">
                  <div>
                    <span [matMenuTriggerFor]="selectToolMenu" class="tool-button" title="Change tool">{{c.Tool}}</span>
                    <mat-menu #selectToolMenu="matMenu">
                      <button mat-menu-item *ngFor="let tool of c.PossibleTools"
                        (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, tool.ToolId, screenId.WF)">{{
                        tool.ToolName
                        }}</button>

                    </mat-menu>
                  </div>
                </td>
                <td *ngIf="!c.Active"></td>
                <td *ngIf="c.Active" class="inspection-component-photo">
                  <div class="photo-container" style="display: flex; gap: 5px;">
                    <div>
                      <upload-photo-wsre-frame (onPhotoUpload)="loadPhoto(c)" [uploadEndPoint]="10"
                        [componentId]="c.InspectionDetailId" [relatedId]="wsreId"></upload-photo-wsre-frame>
                    </div>
                    <ng-container *ngFor="let photo of c.ComponentImages">
                      <div>
                        <img class="comp-image-thumbnail" (click)="openComponentImage(photo.Id, 'framecomp')"
                          [src]="getPhotoThumbnail(photo.ComponentImageUrl)" />
                      </div>
                    </ng-container>
                  </div>
                  <!--<upload-photo-wsre-frame *ngIf="c.PhotoThumbnail == '' || c.PhotoThumbnail == null"
    (onPhotoUpload)="loadPhoto(c)" [uploadEndPoint]="10" [componentId]="c.InspectionDetailId"
    [relatedId]="wsreId"></upload-photo-wsre-frame>
  <i *ngIf="c.PhotoThumbnail != '' && c.PhotoThumbnail != null"
    class="material-icons upload-container__icon"
    style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
    (click)="openComponentImage(c.InspectionDetailId, 'framecomp')">
    add_a_photo
  </i>-->
                </td>
                <td *ngIf="!c.Active"></td>
                <td *ngIf="c.Active" class="inspection-component-photo">
                  <!-- {{c.Comment | slice:0:30}} {{c.Comment?.length>30 ? '...' : ''}} -->
                  <div class="add-recommendation" id="c.InspectionDetailId"
                    [class.has-recommendation]="c.Comment !=='' && c.Comment!== null">
                    <i title="Add/View Comment" class="material-icons"
                      (click)="AddComment(c.InspectionDetailId,c.Comment,true,1,2, screenId.WF)">message</i>
                  </div>
                </td>
                <td *ngIf="!c.Active"></td>
                <td *ngIf="c.Active==true">
                  <i class="material-icons" style="cursor: pointer;"
                    (click)="UpdateVisibilityForComponent(c.InspectionDetailId)"> visibility</i>
                </td>
                <td *ngIf="c.Active==false">
                  <i class="material-icons" style="cursor: pointer;"
                    (click)="UpdateVisibilityForComponent(c.InspectionDetailId)">visibility_off</i>
                </td>
                <td>

                  <div style="display: flex;">
                    <div><button mat-icon-button (click)="loadActions(c.ComponentTypeId,c.ComponentId,'Left')"
                        aria-label="Example icon-button with a menu">
                        <mat-icon>edit</mat-icon>
                      </button></div>
                    <div>
                      <div *ngIf="c.actionHistoryCount > 0; else NoHistory" style="padding-top: 3px;">
                        <i [matTooltip]="c.actionHistoryCount" class="material-icons"
                          style="color: green;cursor: pointer;padding: 3px;" (click)="openHistory(c)">
                          chat_bubble_outline
                        </i>
                      </div>

                      <ng-template #NoHistory>
                        <i [matTooltip]="c.actionHistoryCount" class="material-icons"
                          style="color: rgb(230, 220, 220);padding: 3px;">
                          chat_bubble_outline
                        </i>
                      </ng-template>
                    </div>
                  </div>
                  <div class="popup" #popupRef *ngIf="isPopupVisible && (c.ComponentId == currentClickedId)">
                    <ng-container>
                      <mat-checkbox *ngFor="let option of availableActions" [checked]="selectedOption === option"
                        (change)="onCheckboxChange(option,c.ComponentTypeId,c.ComponentId)">
                        {{ option.ActionTypeName }}
                      </mat-checkbox>

                      <div *ngIf="isReplaceWithNewAction" [@fadeInOut]>
                        <div>
                          <mat-form-field class="input">
                            <mat-select (selectionChange)="replacementCompartChanged($event,c.ComponentId)"
                              [(ngModel)]="action.ReplaceComponentCompartId" placeholder="{{Translate('Compartment')}}">
                              <mat-option *ngFor="let compart of availableCompartments" [value]="compart.Id"
                                [matTooltip]="compart.Name">
                                {{ compart.Name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div
                        *ngIf="+selectedActionTypeID === 10602 || +selectedActionTypeID=== 17 || +selectedActionTypeID === 10702">
                        <mat-form-field class="action-input" *ngIf="allRollers?.length >= 1">
                          <mat-select name="Roller To Swap"
                            placeholder="{{'Select Swap component' | translate | async}}">
                            <mat-option *ngFor="let roller of allRollers" (click)="swapRollerEvent(roller)"
                              [value]="roller">
                              {{ roller.Name }} {{ roller.Position }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <div style="display: flex;">
                      <button mat-raised-button (click)="popupClose()">Close</button>
                      <button mat-raised-button color="warn" (click)="RecordAction()">Save</button>
                    </div>
                  </div>
                </td>
                <td>{{c.NewComponent}}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-block" style="padding: 2%;">
          <span class="text-block__label">Overall Comment</span>
          <span class="text-block__important">
            <edit-data [canEdit]="userCanEdit" [value]="overallComponentLeft" [dataType]="'textarea'"
              (valueChanged)="saveOverallFrameCompComment($event,1, screenId.WF)"></edit-data>
          </span>
        </div>

      </mat-tab>
      <mat-tab label="Right" *ngIf="FrameInspectedSide==3 || FrameInspectedSide==2">
        <div class="panel__content">
           <div class="columnsheadersmgr" *ngIf="isBasicUser==1">
            <mat-checkbox [(ngModel)]="editComponent" *ngIf="isAdministrator" class="margin">
              <span class="example-margin">
                {{"Edit Component" | translate | async}}
              </span>
            </mat-checkbox>
          </div>
        </div>
        <div class="table-container" [@slideOut]
          *ngIf=" RightSideSystem!=null && RightSideSystem.Components.length > 0">
          <table class="table table--full-width table--striped">
            <thead>
              <tr>

                <th></th>
                <th>{{'Component' | translate | async}}</th>
                <th>{{'Pos.' | translate | async}}</th>
                <th>{{'Worn' | translate | async}}</th>
                <th class="right-align" style="text-align-last: center;">{{'Measurement' | translate | async}}</th>
                <th>{{'Tool' | translate | async}}</th>
                <th class="inspection-component-photo-header">Photo</th>
                <th class="inspection-component-photo-header">Comment</th>
                <th class="inspection-component-photo-header">Hide/Show</th>
                <th class="inspection-component-photo-header">Record Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of RightSideSystem.Components">

                <!-- <td *ngIf="c.IsChild">
                  <span style="max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                  </span>
                </td> -->
                <td class="component-cell" *ngIf="!c.IsChild">
                  <div class="component-photo-container">
                    <img class="component-photo" [src]="sanitize(c.ComponentTypeImage)" />
                  </div>
                </td>
                <td *ngIf="c.IsChild" class="line-cell">
                  <div class="line-vert{{getChildRowPosition(c.ComponentId,RightSideSystem)}}"></div>
                  <div class="line-hor"></div>
                </td>

                <td>
                  <span title="{{c.Name}}" *ngIf="!c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
                  </span>
                  <span title="{{c.Name}}" *ngIf="c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}
                    <span *ngIf="editComponent && !c.IsChild">
                    <i
                      class="material-icons text-container__edit"
                      style="cursor:pointer;font-size:16px;"
                      title="Click to edit Component"
                      (click)="openEditComponentPopup(c)">
                      edit
                    </i>
                  </span></span>
                </td>
                <td> {{showPosition(c.Pos, c.ComponentTypeId,RightSideSystem)}}</td>
                <td *ngIf="c.Active" class="table__eval-cell">
                  <span style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                    <div style="text-align: center !important; display: inline-block;">
                      <!-- Eval tool -->
                      <ng-container *ngIf="c.ToolId === toolType.Eval">
                        {{ c.EvalCode }}
                      </ng-container>
                      <!-- Yes/No or Pass/Fail -->
                      <ng-container *ngIf="c.ToolId === toolType.YESorNO || c.ToolId === toolType.PassorFail">
                        {{'-'}}
                      </ng-container>
                      <!-- All others -->
                      <ng-container
                        *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail">
                        {{ c.Measurement === -1 ? '-' : (c.WornPercentage.toFixed(1) + '%') }}
                      </ng-container>
                    </div>
                  </span>
                </td>
                <td *ngIf="c.Active==false"></td>
                <td *ngIf="c.Active==true">
                  <div class="right-align"
                    *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail"
                    style="text-align-last: center;">

                    <input style="width: 100px;" type="number" [(ngModel)]="c.Measurement === -1 ? '' : c.Measurement"
                      (change)="updateComponentMeasurement(c.Measurement, c.InspectionDetailId, $event,c, screenId.WF)">
                    {{c.MeasurementType==1?'MM':'Inch'}}
                  </div>
                  <div *ngIf="c.ToolId === toolType.Eval" class="center-align">
                    <span [matMenuTriggerFor]="evalMenu" class="tool-button"
                      title="{{'Change Eval' | translate | async}}">{{c.EvalCode }}</span>
                    <mat-menu #evalMenu="matMenu">
                      <button mat-menu-item
                        (click)="changeEval('A', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'A'}}</button>
                      <button mat-menu-item
                        (click)="changeEval('B', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'B'}}</button>
                      <button *ngIf="c.isExcludeC==false" mat-menu-item
                        (click)="changeEval('C', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'C' }}</button>
                      <button mat-menu-item
                        (click)="changeEval('X', c.InspectionDetailId,c.ComponentTypeId, screenId.WF)">{{'X'}}</button>
                    </mat-menu>
                  </div>
                  <div class="center-align" *ngIf='c.ToolId === toolType.YESorNO'>
                    <span [matMenuTriggerFor]="yesNoMenu" class="tool-button"
                      title="{{ 'Change Component Yes/No' | translate | async }}">
                      {{c.Measurement === 1 ? ('Yes' | translate | async) :
                      c.Measurement === 0 ? ('No' | translate | async) : ''}}
                    </span>
                    <mat-menu #yesNoMenu="matMenu">
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypeYesNo.Yes, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Yes' | translate | async }}</button>
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypeYesNo.No, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'No' | translate | async }}</button>
                    </mat-menu>
                  </div>
                  <div class="center-align" *ngIf='c.ToolId === toolType.PassorFail'>
                    <span [matMenuTriggerFor]="passFailMenu" class="tool-button"
                      title="{{ 'Change Component Pass/Fail' | translate | async }}">
                      {{ c.Measurement === 1 ? ('Pass' | translate | async) :
                      c.Measurement === 0 ? ('Fail' | translate | async) :''
                      }}
                    </span>
                    <mat-menu #passFailMenu="matMenu">
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypePassFail.Pass, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Pass' | translate | async }}</button>
                      <button mat-menu-item
                        (click)="updateComponentMeasurement(toolTypePassFail.Fail, c.InspectionDetailId, null,c, screenId.WF)">{{
                        'Fail' | translate | async }}</button>
                    </mat-menu>
                  </div>
                </td>
                <td *ngIf="c.Active==false"></td>
                <td *ngIf="c.Active==true">
                  <div>
                    <span [matMenuTriggerFor]="selectToolMenu" class="tool-button" title="Change tool">{{c.Tool}}</span>
                    <mat-menu #selectToolMenu="matMenu">
                      <button mat-menu-item *ngFor="let tool of c.PossibleTools"
                        (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, tool.ToolId, screenId.WF)">{{
                        tool.ToolName
                        }}</button>

                    </mat-menu>
                  </div>
                </td>
                <td *ngIf="!c.Active"></td>

                <td *ngIf="c.Active" class="inspection-component-photo">
                  <div class="photo-container" style="display: flex; gap: 5px;">
                    <div>
                      <upload-photo-wsre-frame (onPhotoUpload)="loadPhoto(c)" [uploadEndPoint]="10"
                        [componentId]="c.InspectionDetailId" [relatedId]="wsreId"></upload-photo-wsre-frame>
                    </div>
                    <ng-container *ngFor="let photo of c.ComponentImages">
                      <div>
                        <img class="comp-image-thumbnail" (click)="openComponentImage(photo.Id, 'framecomp')"
                          [src]="getPhotoThumbnail(photo.ComponentImageUrl)" title="View/Edit photo" />
                      </div>
                    </ng-container>
                  </div>
                  <!--<upload-photo-wsre-frame *ngIf="c.PhotoThumbnail == '' || c.PhotoThumbnail == null"
    (onPhotoUpload)="loadPhoto(c)" [uploadEndPoint]="10" [componentId]="c.InspectionDetailId"
    [relatedId]="wsreId"></upload-photo-wsre-frame>
  <i *ngIf="c.PhotoThumbnail != '' && c.PhotoThumbnail != null"
    class="material-icons upload-container__icon"
    style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;"
    (click)="openComponentImage(c.InspectionDetailId, 'framecomp')">
    add_a_photo
  </i>-->
                </td>
                <td *ngIf="c.Active==false"></td>
                <td *ngIf="c.Active==true" class="inspection-component-photo">
                  <div class="add-recommendation" id="c.InspectionDetailId"
                    [class.has-recommendation]="c.Comment !=='' && c.Comment!== null">
                    <i title="Add/View Comment" class="material-icons"
                      (click)="AddComment(c.InspectionDetailId,c.Comment,true,1,2,screenId.WF)">message</i>
                  </div>
                </td>
                <td *ngIf="c.Active==false"></td>
                <td *ngIf="c.Active==true">
                  <i class="material-icons" style="cursor: pointer;"
                    (click)="UpdateVisibilityForComponent(c.InspectionDetailId)"> visibility</i>
                </td>
                <td *ngIf="c.Active==false">
                  <i class="material-icons" style="cursor: pointer;"
                    (click)="UpdateVisibilityForComponent(c.InspectionDetailId)">visibility_off</i>
                </td>
                <td>
                  <div style="display: flex;">
                    <div><button mat-icon-button (click)="loadActions(c.ComponentTypeId,c.ComponentId,'Right')"
                        aria-label="Example icon-button with a menu">
                        <mat-icon>edit</mat-icon>
                      </button></div>
                    <div>
                      <div *ngIf="c.actionHistoryCount > 0; else NoHistory" style="padding-top: 3px;">
                        <i [matTooltip]="c.actionHistoryCount" class="material-icons"
                          style="color: green;cursor: pointer;padding: 3px;" (click)="openHistory(c)">
                          chat_bubble_outline
                        </i>
                      </div>
                      <ng-template #NoHistory>
                        <i [matTooltip]="c.actionHistoryCount" class="material-icons"
                          style="color: rgb(230, 220, 220);padding: 3px;">
                          chat_bubble_outline
                        </i>
                      </ng-template>
                    </div>
                  </div>
                  <div class="popup" #popupRef *ngIf="isPopupVisible && (c.ComponentId == currentClickedId)">
                    <ng-container>
                      <mat-checkbox *ngFor="let option of availableActions" [checked]="selectedOption === option"
                        (change)="onCheckboxChange(option,c.ComponentTypeId,c.ComponentId)">
                        {{ option.ActionTypeName
                        }}
                      </mat-checkbox>

                      <div *ngIf="isReplaceWithNewAction" [@fadeInOut]>
                        <div>
                          <mat-form-field class="input">
                            <mat-select (selectionChange)="replacementCompartChanged($event,c.ComponentId)"
                              [(ngModel)]="ReplaceComponentCompartId" placeholder="{{Translate('Compartment')}}">
                              <mat-option *ngFor="let compart of availableCompartments" [value]="compart.Id"
                                [matTooltip]="compart.Name">
                                {{ compart.Name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <div
                        *ngIf="+selectedActionTypeID === 10602 || +selectedActionTypeID=== 17 || +selectedActionTypeID === 10702">
                        <mat-form-field class="action-input" *ngIf="allRollers?.length >= 1">
                          <mat-select name="Roller To Swap"
                            placeholder="{{'Select Swap component' | translate | async}}">
                            <mat-option *ngFor="let roller of allRollers" (click)="swapRollerEvent(roller)"
                              [value]="roller">
                              {{ roller.Name }} {{ roller.Position }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <div style="display: flex;">
                      <button mat-raised-button (click)="popupClose()">Close</button>
                      <button mat-raised-button color="warn" (click)="RecordAction()">Save</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-block" style="padding: 2%;">
          <span class="text-block__label">Overall Comment</span>
          <span class="text-block__important">
            <edit-data [canEdit]="userCanEdit" [value]="overallComponentRight" [dataType]="'textarea'"
              (valueChanged)="saveOverallFrameCompComment($event,2, screenId.WF)"></edit-data>
          </span>
        </div>
      </mat-tab>
      <mat-tab label="Audit Trail">
        <app-audit-trail *ngIf="systemIdLeft || systemIdRight" [systemIdLeft]="systemIdLeft"
          [systemIdRight]="systemIdRight" [moduleId]="4" [screenId]="2"
          [refreshData]="auditRefreshCounter"></app-audit-trail>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
